
export const LANG_DE_NAME = 'de';

export const LANG_DE_TRANS = {
  // in colorPicker.dialog
  'COLOR_PICKER': 'Farbpalette',
  'SUCCESSFULLY_LOGGED_IN': 'Erfolgreich eingeloggt',
  // in content.component
  "ONLY_SHOW_DATA": "Ich zeige lediglich Daten",
  "READY_FOR_CHECK": "Bereit für die Zeiterfassung",
  "WORK_TIME": "Arbeitszeit",
  "BREAK_TIME": "Pausenzeit",
  "TO_DO": "Zu erledigen",
  // in reconnect.dialog
  "SUCCESSFULLY_DISCNNECTED": "Verbindung erfolgreich getrennt",
  "RECONNECT": "Verbindung wieder herstellen",
  // in settings.dialog
  'SETTINGS': 'Einstellungen',
  "SHOW_WORKERS": "Zeige Mitarbeiter",
  "WORKER_FILTER": "Mitarbeiter Filter",
  "WORKER_FILTER_DEFAULT": "Standard",
  "WORKER_FILTER_ALL": "Alle anzeigen",
  "WORKER_FILTER_CHECKEDIN": "Alle Eingecheckten anzeigen",
  "WORKER_FILTER_DISABLED_HINT": "Sie können diese Option in der Schnittstelle von projectfacts aktivieren",
  "WORKER_IMAGES": "Mitarbeiter Bilder",
  "WORKER_COLUMN_COUNT": "Maximale Spalten Anzahl",
  "WORKER_SHOW_ABSENT": "Abwesende Mitarbeiter",
  "FULL_DATA_RESET": "Vollständiges zurücksetzen der Daten",
  "CLEAR_ALL_DATA": "Löscht alle lokalen Daten. Einschließlich der Verbindung zu Projectfacts und alle Einstellungen",
  "VERSION": "Version",
  "SHOW_WORKERBACKGROUND": "Zeige Hintergrundbild bei check in/out",
  "LITTLE_MESSAGE_BLOCK": "Kleine Zeitanzeige",
  // in login.component
  "WRONG_DATA_INPUT": "Falsche Daten eingegeben. Versuchen Sie es erneut.",
  "TERMINAL_IS_OFFLINE": "Verbindungsaufbau fehlgeschlagen. Das Terminal ist offline!",
  "INPUT_FIELD_IS_EMPTY": "Eingabefeld ist leer",
  "TERMINAL_ID": "Terminal ID",
  "TERMINAL_PASSWORD": "Terminal Passwort",
  "CONNECT": "Verbinden",
  // in app.service
  "WRONG_DATA_AT_STORAGE": "Falsche Daten im lokalem Speicher",
  "CONNECTION_FAILED": "Verbindungsaufbau fehlgeschlagen",
  // in content.service
  "LOGGED_IN_SUCCESSFULLY": "hat sich eingeloggt",
  "LOGGED_OUT_SUCCESSFULLY": "hat sich ausgeloggt",
  "CHECK_IS_NOT_ALLOWED": "Die benötigte Berechtigung fehlt bei Projectfacts - Ein/Auschecken ist nicht erlaubt",
  "CHECK_CAN_NOT_SAVED": "Das Ein/Auschecken kann nicht in Projectsfacts gespeichert werden",
  "UNKNOWN_USER_RFID": "Unbekannte Nutzer-RFID",
  // in workerList.dialog
  "LOGGEDIN_WORKERS": "Mitarbeiter",
  "ABSENT_WORKERS": "Abwesende Mitarbeiter",
  "CHECK_IN": "Check-in",
  "CHECK_OUT": "Check-out"
};
